import Layout from '@/layout/layout'

const StoreShopRouter = {
    path: '/StoreShop',
    component: Layout,
    redirect: 'noRedirect',
    name: '门店商家',
    children: [
        {
            path: 'index',
            component: () => import('@/views/StoreShop/index'),
            name: '商家列表',
            meta: {title: '商家列表', noCache: true}
        },
        {
            path: 'Addstore',
            component: () => import('@/views/StoreShop/Addstore'),
            name: '添加商家',
            meta: {title: '添加商家', noCache: true}
        },
        {
            path: "priceMarkup",
            component: () => import("@/views/StoreShop/PriceMarkup.vue"),
            name: "平台加价设置",
            meta: {
                title: '平台加价设置',
                noCache: true
            }
        },
        {
            path: 'editStore',
            component: () => import('@/views/StoreShop/Addstore'),
            name: '编辑商家',
            meta: {title: '编辑商家', noCache: true}
        },
        {
            path: 'blacklist',
            component: () => import('@/views/StoreShop/blacklist/index'),
            name: '黑名单门店管理',
            meta: {title: '黑名单门店管理', noCache: true}
        },
        {
            path: 'mobileStoreManage',
            component: () => import('@/views/StoreShop/mobileStoreManage/index'),
            name: '移动门店店员管理',
            meta: {title: '移动门店店员管理', noCache: true}
        },
           {
            path: 'clerksAKbinding',
            component: () => import('@/views/StoreShop/clerksAKbinding/index'),
            name: '繁星KA和店员绑定',
            meta: {title: '繁星KA和店员绑定', noCache: true}
        },
    ]
}

export default StoreShopRouter
